<template>
    <div>
        <div class="datagrid">
            <b-table small striped hover :items="items" :fields="fields" :per-page="0" :current-page="currentPage"
                table-class="customtable" thead-class="customtable__header" tbody-tr-class="customtable__tr">
            </b-table>
        </div>
        <b-row>
            <b-col cols="4">
                <b-pagination size="sm" pills v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                    @change="handlePageChange" aria-controls="my-table" id="perPageSelect"></b-pagination>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data: function () {
        return {
            perPageOptions: [5, 10, 15],
            perPage:10
        };
    },
    props: {
        items: {
            type: Array,
        },
        fields: {
            type: Array,
        },
        currentPage: {
            type : Number
        }
    },

    methods: {
        handlePageChange(value) {
            this.page = value;
            this.$emit("pagination", { page: this.page, perPage: this.perPage });
        }
    },
    computed: {
        totalRows() {
            return this.items ? this.items[0].count : 0;
        },
    },
};
</script>
<style scoped>
.datagrid {
    min-height: 400px;
}

.customtable__icon {
    font-size: 12px;
}

.customtable__button-edit {
    color: orange;
    padding-right: 10%;
}
</style>
  